var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("el-upload", {
        directives: [
          { name: "show", rawName: "v-show", value: false, expression: "false" }
        ],
        staticClass: "avatar-uploader",
        attrs: {
          action: _vm.uploadUrl,
          accept: "image/*",
          "on-success": _vm.uploadSuccess
        }
      }),
      _vm._v(" "),
      _c("el-button", {
        directives: [
          { name: "show", rawName: "v-show", value: false, expression: "false" }
        ],
        attrs: { id: "videoButton" },
        on: {
          click: function($event) {
            _vm.videoForm.show = true
          }
        }
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticStyle: { "margin-top": "1px" },
          attrs: {
            "close-on-click-modal": false,
            width: "50%",
            visible: _vm.videoForm.show,
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.videoForm, "show", $event)
            }
          }
        },
        [
          _c(
            "el-tabs",
            {
              model: {
                value: _vm.videoForm.activeName,
                callback: function($$v) {
                  _vm.$set(_vm.videoForm, "activeName", $$v)
                },
                expression: "videoForm.activeName"
              }
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "添加视频链接", name: "first" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入视频链接", clearable: "" },
                    model: {
                      value: _vm.videoForm.videoLink,
                      callback: function($$v) {
                        _vm.$set(_vm.videoForm, "videoLink", $$v)
                      },
                      expression: "videoForm.videoLink"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "submit-upload",
                      on: {
                        click: function($event) {
                          return _vm.insertVideoLink(_vm.videoForm.videoLink)
                        }
                      }
                    },
                    [_vm._v("确认\n        ")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { label: "本地视频上传", name: "second" } },
                [
                  _c(
                    "el-upload",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loading,
                          expression: "loading"
                        }
                      ],
                      staticStyle: { "text-align": "center" },
                      attrs: {
                        drag: "",
                        action: _vm.uploadUrl,
                        accept: "video/*",
                        "before-upload": _vm.onBeforeUploadVideo,
                        "on-success": _vm.onSuccessVideo,
                        "on-error": _vm.onErrorVideo,
                        multiple: false
                      }
                    },
                    [
                      _c("i", { staticClass: "el-icon-upload" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "el-upload__text" }, [
                        _vm._v("\n            将文件拖到此处，或"),
                        _c("em", [_vm._v("点击上传")])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "el-upload__tip",
                          attrs: { slot: "tip" },
                          slot: "tip"
                        },
                        [
                          _vm._v(
                            "\n            文件大小不能不超过10M\n          "
                          )
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("quill-editor", {
        ref: "myQuillEditor",
        attrs: { options: _vm.editorOption },
        on: {
          blur: function($event) {
            return _vm.onEditorBlur($event)
          },
          focus: function($event) {
            return _vm.onEditorFocus($event)
          },
          change: function($event) {
            return _vm.onEditorChange($event)
          },
          ready: function($event) {
            return _vm.onEditorReady($event)
          }
        },
        model: {
          value: _vm.content,
          callback: function($$v) {
            _vm.content = $$v
          },
          expression: "content"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5d53a346", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d53a346","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/components/quillEditor.vue
// module id = 4j1w
// module chunks = 2